function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Tool_Arrastre"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Tool_Arrastre",
  "data-name": "Tool Arrastre",
  clipPath: "url(#clip-Tool_Arrastre)"
}, React.createElement("g", {
  id: "Icono",
  transform: "translate(4 4)",
  fill: "none",
  stroke: "#091832",
  strokeWidth: 2
}, React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 9,
  stroke: "none"
}), React.createElement("rect", {
  x: 1,
  y: 1,
  width: 38,
  height: 38,
  rx: 8,
  fill: "none"
})), React.createElement("path", {
  id: "Path_139",
  "data-name": "Path 139",
  d: "M23.94,39.863,24,39.91a8.842,8.842,0,0,0,3.855,1.542,14.962,14.962,0,0,0,1.933.124,10.674,10.674,0,0,0,6.827-2.158,8.986,8.986,0,0,0,3.053-6.73V25.608a2.985,2.985,0,0,0-4.685-2.484,2.938,2.938,0,0,0-2.852-2.449,2.862,2.862,0,0,0-2.2,1.046,2.91,2.91,0,0,0-3.813-.581V16.1a2.912,2.912,0,1,0-5.812,0v12l-1.027-.779a3.013,3.013,0,0,0-4.2,4.32Zm-7.784-11.4a1.466,1.466,0,0,1,2.069,0,.758.758,0,0,0,.081.07l2.309,1.751a.775.775,0,0,0,1.244-.62V16.1a1.473,1.473,0,0,1,1.36-1.55,1.452,1.452,0,0,1,1.352,1.55V27.336a.775.775,0,0,0,1.55,0V23.849A1.709,1.709,0,0,1,27.7,22.226a1.661,1.661,0,0,1,1.523,1.624v3.677a.775.775,0,0,0,1.55,0V23.69a1.36,1.36,0,1,1,2.712,0v3.836a.775.775,0,1,0,1.55,0v-1.74a1.767,1.767,0,0,1,1.62-1.643,1.466,1.466,0,0,1,1.465,1.465v7.013a7.492,7.492,0,0,1-2.5,5.6c-2.519,2.088-6.134,1.875-7.571,1.689A7.355,7.355,0,0,1,24.963,38.7l-8.807-8.168a1.459,1.459,0,0,1,0-2.069Z",
  transform: "translate(-13.78 13.576) rotate(-30)",
  fill: "#091832",
  stroke: "#091832",
  strokeWidth: 0.5
}));

var SvgToolArrastre = function SvgToolArrastre(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgToolArrastre, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tool Arrastre.b81798a9.svg";
export { ForwardRef as ReactComponent };